module.exports = __webpack_public_path__ + "img/max-file-transfer--csv.e9b7fa31.svg";